/* Publish by EComposer at 2026-10-07 21:08:58*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e5m9tb63e18"]=  window.__ectimmers["ecom-e5m9tb63e18"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-e5m9tb63e18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5m9tb63e18', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ksofg0anlu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ksofg0anlu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n2t0tywuzwc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n2t0tywuzwc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vc2s3z78zuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vc2s3z78zuj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4c98m6xtef7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4c98m6xtef7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ytp1nn6e3bf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ytp1nn6e3bf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mvouwclbkg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mvouwclbkg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5koz6lj2fy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5koz6lj2fy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v046bv2y4ma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v046bv2y4ma', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbv2hn2ad49').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbv2hn2ad49', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qcf94ceeu8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qcf94ceeu8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ygy3jl84y6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ygy3jl84y6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sppu6io7a1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sppu6io7a1', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6bac1nb85bd"]=  window.__ectimmers["ecom-6bac1nb85bd"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-6bac1nb85bd"]["bfziwjyni"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-6bac1nb85bd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6bac1nb85bd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b1h8jp62tuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b1h8jp62tuj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-av002sl05hf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-av002sl05hf', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kqyjkrc0o1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqyjkrc0o1r', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpdoakxnet').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpdoakxnet', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8gqplljxig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8gqplljxig', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ngdtdnz6qsp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ngdtdnz6qsp', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4s0jjezulc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4s0jjezulc', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jw7pb82iz9d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jw7pb82iz9d', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-scxbr0gyyq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-scxbr0gyyq', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y63fhqrlq1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y63fhqrlq1r', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrmz7p0eu5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrmz7p0eu5', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9nkk729ng4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9nkk729ng4j', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}